export const APP_NAME = process.env.REACT_APP_WEBSITE_NAME;
export const BASE_URL = process.env.REACT_APP_BASE_API_URL;
export const MEDIA_URL = process.env.REACT_APP_COMMON_API_URL;
export const WEB_MEDIA_BUCKET_URL = process.env.REACT_APP_WEB_MEDIA_BUCKET_URL;
export const TRAVALOUR_URL = process.env.REACT_APP_TRAVALOUR_URL;
export const GOOGLE_MAP_API_URL = process.env.REACT_APP_GOOGLE_MAP_API_URL;
export const GOOGLE_MAP_API_KEY = process.env.REACT_APP_GOOGLE_MAP_API_KEY;

// export const SESSION_TIMEOUT_MINS = 60;
export const MENU_DRAWER_WIDTH = 240;
export const RECORDS_FETCH_LIMIT = 20;
export const NEAR_BY_SEARCH_DISTANCE = 5000; //in meter
export const MEDIA_ORIGINAL_URL = `${MEDIA_URL}/get-original`; // */{mediaId}
export const MEDIA_THUMBNAIL_URL = `${MEDIA_URL}/thumbnail`; // */{mediaId}?width=xx*
export const HTTP_REQUEST_TIMEOUT = 16000;

export const IMG_BG_COLOR = "#3b3b3b";
/*----- Place Holder Images -----*/
//120,360,480,720,960,1440,1920
export const PLACEHOLDER_IMG_120x120_URL = `${WEB_MEDIA_BUCKET_URL}/placeholder/image/120x120.png`;
export const PLACEHOLDER_IMG_120x120_ERROR_URL = `${WEB_MEDIA_BUCKET_URL}/placeholder/error/120x120.png`;
export const PLACEHOLDER_IMG_360x360_URL = `${WEB_MEDIA_BUCKET_URL}/placeholder/image/360x360.png`;
export const PLACEHOLDER_IMG_360x360_ERROR_URL = `${WEB_MEDIA_BUCKET_URL}/placeholder/error/360x360.png`;
export const PLACEHOLDER_IMG_480x480_URL = `${WEB_MEDIA_BUCKET_URL}/placeholder/image/480x480.png`;
export const PLACEHOLDER_IMG_480x480_ERROR_URL = `${WEB_MEDIA_BUCKET_URL}/placeholder/error/480x480.png`;
export const PLACEHOLDER_IMG_720x480_URL = `${WEB_MEDIA_BUCKET_URL}/placeholder/image/720x480.png`;
export const PLACEHOLDER_IMG_720x480_ERROR_URL = `${WEB_MEDIA_BUCKET_URL}/placeholder/error/720x480.png`;
export const PLACEHOLDER_IMG_720x720_URL = `${WEB_MEDIA_BUCKET_URL}/placeholder/image/720x720.png`;
export const PLACEHOLDER_IMG_720x720_ERROR_URL = `${WEB_MEDIA_BUCKET_URL}/placeholder/error/720x720.png`;
export const PLACEHOLDER_IMG_960x720_URL = `${WEB_MEDIA_BUCKET_URL}/placeholder/image/960x720.png`;
export const PLACEHOLDER_IMG_960x720_ERROR_URL = `${WEB_MEDIA_BUCKET_URL}/placeholder/error/960x720.png`;
/*----- Map Marker Images -----*/
export const MARKER_GREEN_URL = `${WEB_MEDIA_BUCKET_URL}/logo/icon/green-1-32.png`;
export const MARKER_RED_URL = `${WEB_MEDIA_BUCKET_URL}/logo/icon/red-1-32.png`;
export const MARKER_BLUE_URL = `${WEB_MEDIA_BUCKET_URL}/logo/icon/blue-1-32.png`;
export const MARKER_BLACK_URL = `${WEB_MEDIA_BUCKET_URL}/logo/icon/black-1-32.png`;
export const MARKER_BROWN_URL = `${WEB_MEDIA_BUCKET_URL}/logo/icon/brown-1-32.png`;
/*----- Colors -----*/
export const COLOR_TRAVALOUR = "#095460";
export const COLOR_RED = "#933232";
export const COLOR_GREEN = "#397932";
export const COLOR_BROWN = "#795627";
export const COLOR_BLUE = "#40759F";
export const COLOR_GRAY = "#656A6F";
/*----- Regex -----*/
// eslint-disable-next-line
export const REGEX_COLOR = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
// BELOW REGEX WILL NOT WORK ON SAFARI
// export const REGEX_USERNAME = /^(?=.{5,20}$)(?![_.])(?!.*[_.]{2})[a-zA-Z0-9._]+(?<![_.])$/;
export const REGEX_USERNAME = /^[a-z0-9]*$/;
export const REGEX_PASSWORD = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/;
// eslint-disable-next-line
// export const REGEX_URL = /^(https?):\/\/((?:[a-z0-9.-]|%[0-9A-F]{2}){3,})(?::(\d+))?((?:\/(?:[a-z0-9-._~!$&'()*+,;=:@]|%[0-9A-F]{2})*)*)(?:\?((?:[a-z0-9-._~!$&'()*+,;=:/?@]|%[0-9A-F]{2})*))?(?:#((?:[a-z0-9-._~!$&'()*+,;=:/?@]|%[0-9A-F]{2})*))?$/i;
// eslint-disable-next-line
export const REGEX_URL = /^https?:\/\/[a-z0-9_\-]+\b\.[a-z0-9_\-\.]+\b([-a-zA-Z0-9@:%_\+.~#?&\/\/=]*)/i;
// eslint-disable-next-line
export const REGEX_URL_HTTPS = /^https:\/\/[a-z0-9_\-]+\b\.[a-z0-9_\-\.]+\b([-a-zA-Z0-9@:%_\+.~#?&\/\/=]*)/i;
/*----- ACL -----*/
export const ACL_GET_ROLES_LIST_URL = {
  url: `${BASE_URL}/acl/get-roles-list`,
  method: "get",
};
export const ACL_GET_PERMISSIONS_LIST_URL = {
  url: `${BASE_URL}/acl/get-permissions-list`,
  method: "get",
};
export const ACL_GET_USERS_LIST_URL = {
  url: `${BASE_URL}/acl/get-users-list`,
  method: "get",
};
export const ACL_GET_USER_URL = {
  url: `${BASE_URL}/acl/get-user`, // */{userId}
  method: "get",
};
export const ACL_GET_ROLE_URL = {
  url: `${BASE_URL}/acl/get-role`, // */{roleId}
  method: "get",
};
export const ACL_CREATE_USER_URL = {
  url: `${BASE_URL}/acl/create-user`,
  method: "post",
};
export const ACL_CREATE_ROLE_URL = {
  url: `${BASE_URL}/acl/create-role`,
  method: "post",
};
export const ACL_EDIT_ROLE_URL = {
  url: `${BASE_URL}/acl/edit-role`, // */{roleId}
  method: "post",
};
export const ACL_DELETE_ROLE_URL = {
  url: `${BASE_URL}/acl/delete-role`, // */{roleId}
  method: "post",
};
export const ACL_EDIT_USER_URL = {
  url: `${BASE_URL}/acl/edit-user`, // */{userId}
  method: "post",
};
export const ACL_UNBLOCK_USER_URL = {
  url: `${BASE_URL}/acl/unblock-user`, // */{userId}
  method: "post",
};

/*----- System -----*/
export const SYS_GET_DOCUMENT_URL = {
  url: `${BASE_URL}/sys/get-doc`, // */{docType}
  method: "get",
};
export const SYS_EDIT_DOCUMENT_URL = {
  url: `${BASE_URL}/sys/edit-doc`, // */{docType}
  method: "post",
};

/*----- Adm Areas -----*/
export const ADM_AREAS_DETAILS_URL = {
  url: `${BASE_URL}/adm-areas/id`, // */{admId}
  method: "get",
};
export const ADM_AREAS_CHILD_LIST_URL = {
  url: `${BASE_URL}/adm-areas/child-list`, // */{admId}
  method: "get",
};
export const COUNTRY_LIST_URL = {
  url: `${BASE_URL}/adm-areas/country-list`,
  method: "get",
};
export const ADM_AREAS_LOCATION_LIST_URL = {
  url: `${BASE_URL}/adm-areas/loc-list`, // */{admId} ? page= (optional) & limit= (optional)
  method: "get",
};
export const ADM_AREAS_CREATE_URL = {
  url: `${BASE_URL}/adm-areas/create`,
  method: "put",
};
export const ADM_AREAS_EDIT_URL = {
  url: `${BASE_URL}/adm-areas/edit`, // */{admId}
  method: "post",
};
export const ADM_AREAS_DELETE_URL = {
  url: `${BASE_URL}/adm-areas/delete`, // */{admId}
  method: "delete",
};
export const ADM_AREAS_CORRECTION_CREATE_URL = {
  url: `${BASE_URL}/adm-areas/corrections/create`, // */{admId}
  method: "put",
};
export const ADM_AREAS_CORRECTION_EDIT_URL = {
  url: `${BASE_URL}/adm-areas/corrections/edit`, // */{correctionId}
  method: "post",
};
export const ADM_AREAS_CORRECTION_DELETE_URL = {
  url: `${BASE_URL}/adm-areas/corrections/delete`, // */{correctionId}
  method: "delete",
};
export const ADM_AREAS_MEDIA_GET_LIST_URL = {
  url: `${BASE_URL}/adm-areas/media/get-list`, // */{admId}
  method: "get",
};
export const ADM_AREAS_MEDIA_CREATE_URL = {
  url: `${BASE_URL}/adm-areas/media/create`, // */{admId}
  method: "put",
};
export const ADM_AREAS_MEDIA_EDIT_URL = {
  url: `${BASE_URL}/adm-areas/media/edit`, // */{admMediaId}
  method: "post",
};
export const ADM_AREAS_MEDIA_DELETE_URL = {
  url: `${BASE_URL}/adm-areas/media/delete`, // */{admMediaId}
  method: "delete",
};
export const ADM_AREAS_MEDIA_SWAP_URL = {
  url: `${BASE_URL}/adm-areas/media/swap`, // */{admId}
  method: "post",
};
export const ADM_AREAS_MEDIA_LAST_SEQUENCE_URL = {
  url: `${BASE_URL}/adm-areas/media/last-sequence`, // */{admId}
  method: "get",
};
export const ADM_AREAS_LATEST_COMMENTS_URL = {
  url: `${BASE_URL}/adm-areas/comments/latest-comments`,
  method: "get",
};
/*----- Auth -----*/
export const AUTH_LOGIN_URL = {
  url: `${BASE_URL}/auth/login`,
  method: "post",
};
export const AUTH_LOGOUT_URL = {
  url: `${BASE_URL}/auth/logout`,
  method: "post",
};
export const AUTH_CHANGE_PASSWORD = {
  url: `${BASE_URL}/auth/profile/change-pwd`,
  method: "post",
};
export const AUTH_VERIFY_PASSWORD = {
  url: `${BASE_URL}/auth/profile/verify-pwd`,
  method: "post",
};
export const AUTH_REFRESH_ACCESS_TOKEN_URL = {
  url: `${BASE_URL}/auth/refresh-access-token`,
  method: "post",
};
export const AUTH_COGNITO_TEMP_TOKEN_URL = {
  url: `${BASE_URL}/auth/cognito/temp-token`,
  method: "post",
};
/*----- Activities -----*/
export const ACTIVITIES_SEARCH_URL = {
  url: `${BASE_URL}/activities/search`, // ? name= (optional) & status= (optional) & type= (optional) & page= (optional) & limit= (optional) & sort= (optional) & order= (optional)
  method: "get",
};
/*----- Articles -----*/
export const ARTICLE_SEARCH_URL = {
  url: `${BASE_URL}/article/search`, // ? name= (optional) & status= (optional) & user= (optional) & page= (optional) & limit= (optional) & sort= (optional) & order= (optional)
  method: "get",
};
export const ARTICLE_DETAILS_URL = {
  url: `${BASE_URL}/article/id`, // */{articleId}
  method: "get",
};
export const ARTICLE_SUSPEND_URL = {
  url: `${BASE_URL}/article/suspend`, // */{articleId}
  method: "post",
};

/*----- Categories -----*/
export const CATEGORY_LIST_URL = {
  url: `${BASE_URL}/cat/get-list`,
  method: "get",
};
export const CATEGORY_CREATE_URL = {
  url: `${BASE_URL}/cat/create`,
  method: "put",
};
export const CATEGORY_EDIT_URL = {
  url: `${BASE_URL}/cat/edit`, // */{catId}*
  method: "post",
};
export const CATEGORY_DELETE_URL = {
  url: `${BASE_URL}/cat/delete`, // */{catId}*
  method: "delete",
};
export const SUB_CATEGORY_CREATE_URL = {
  url: `${BASE_URL}/cat/sub/create`, // */{catId}*
  method: "put",
};
export const SUB_CATEGORY_EDIT_URL = {
  url: `${BASE_URL}/cat/sub/edit`, // */{subCatId}*
  method: "post",
};
export const SUB_CATEGORY_DELETE_URL = {
  url: `${BASE_URL}/cat/sub/delete`, // */{subCatId}*
  method: "delete",
};
/*----- Dashboard -----*/
export const DASHBOARD_STATS_URL = {
  url: `${BASE_URL}/dashboard/stats`,
  method: "get",
};
/*----- Dev Settings -----*/
export const DEV_API_DOC_GET_LIST_URL = {
  url: `${BASE_URL}/dev/api-doc/get-list`,
  method: "get",
};
export const DEV_API_DOC_GET_BY_ID_URL = {
  url: `${BASE_URL}/dev/api-doc/id`,   // */{apiDocId}*
  method: "get",
};
export const DEV_API_DOC_EDIT_URL = {
  url: `${BASE_URL}/dev/api-doc/edit`,   // */{apiDocId}*
  method: "post",
};
export const DEV_API_DOC_EDIT_DATA_URL = {
  url: `${BASE_URL}/dev/api-doc/edit-data`,   // */{apiDocId}*
  method: "post",
};
export const DEV_API_DOC_DETAIL_CREATE_URL = {
  url: `${BASE_URL}/dev/api-doc/details/create`,   // */{apiDocId}*
  method: "put",
};
export const DEV_API_DOC_DETAIL_GET_URL = {
  url: `${BASE_URL}/dev/api-doc/details/id`,   // */{apiDocDetailId}*
  method: "get",
};
export const DEV_API_DOC_DETAIL_EDIT_URL = {
  url: `${BASE_URL}/dev/api-doc/details/edit`,   // */{apiDocDetailId}*
  method: "post",
};
export const DEV_API_DOC_DETAIL_EDIT_DATA_URL = {
  url: `${BASE_URL}/dev/api-doc/details/edit-data`,   // */{apiDocDetailId}*
  method: "post",
};
export const DEV_API_DOC_DETAIL_DELETE_URL = {
  url: `${BASE_URL}/dev/api-doc/details/delete`,   // */{apiDocDetailId}*
  method: "delete",
};

/*----- Feedback -----*/
export const FEEDBACK_GET_LIST_URL = {
  url: `${BASE_URL}/feedback/get-list`, // ?page= (optional) & limit= (optional)
  method: "get",
};
export const FEEDBACK_RESPOND_URL = {
  url: `${BASE_URL}/feedback/respond`, // */{feedbackId}*
  method: "post",
};

/*----- Google API Proxy -----*/
export const GOOGLE_PLACE_AUTOCOMPLETE_URL = {
  url: `${BASE_URL}/google/place/autocomplete`, // *google api query params except "key"*
  method: "get",
};
export const GOOGLE_PLACE_DETAILS_URL = {
  url: `${BASE_URL}/google/place/details`, // *google api query params except "key"*
  method: "get",
};
export const GOOGLE_GEO_CODING_API_URL = {
  url: `${BASE_URL}/google/geocode`, // *google api query params except "key"*
  method: "get",
};
/*----- Location -----*/
export const LOCATION_DETAILS_URL = {
  url: `${BASE_URL}/loc/id`, // */{locationId}*
  method: "get",
};
export const LOCATION_GOOGLE_PLACE_ID_CHECK_URL = {
  url: `${BASE_URL}/loc/check-google-place-id`, // */{googlePlaceId}*
  method: "get",
};
export const LOCATION_CREATE_URL = {
  url: `${BASE_URL}/loc/create`,
  method: "put",
};
export const LOCATION_EDIT_URL = {
  url: `${BASE_URL}/loc/edit`, // */{locationId}
  method: "post",
};
export const LOCATION_DELETE_URL = {
  url: `${BASE_URL}/loc/delete`, // */{locationId}
  method: "delete",
};
export const LOCATION_MERGE_URL = {
  url: `${BASE_URL}/loc/merge`, // */{locationId}
  method: "post",
};
export const LOCATION_CATEGORY_EDIT_URL = {
  url: `${BASE_URL}/loc/category/edit`, // */{locationId}
  method: "post",
};
export const LOCATION_CHANGE_STATUS_URL = {
  url: `${BASE_URL}/loc/change-status`, // */{locationId}
  method: "post",
};
export const LOCATION_CHANGE_ADM_AREA_URL = {
  url: `${BASE_URL}/loc/change-adm`, // */{locationId}
  method: "post",
};
export const LOCATION_MEDIA_GET_LIST_URL = {
  url: `${BASE_URL}/loc/media/get-list`, // */{locationId}
  method: "get",
};
export const LOCATION_MEDIA_CREATE_URL = {
  url: `${BASE_URL}/loc/media/create`, // */{locationId}
  method: "put",
};
export const LOCATION_MEDIA_EDIT_URL = {
  url: `${BASE_URL}/loc/media/edit`, // */{locationMediaId}
  method: "post",
};
export const LOCATION_MEDIA_DELETE_URL = {
  url: `${BASE_URL}/loc/media/delete`, // */{locationMediaId}
  method: "delete",
};
export const LOCATION_MEDIA_SWAP_URL = {
  url: `${BASE_URL}/loc/media/swap`, // */{locationId}
  method: "post",
};
export const LOCATION_MEDIA_LAST_SEQUENCE_URL = {
  url: `${BASE_URL}/loc/media/last-sequence`, // */{locationId}
  method: "get",
};
export const LOCATION_SEARCH_TEXT_URL = {
  url: `${BASE_URL}/loc/search/by-text`, // ? name= (optional) & cat= (optional) & status= (optional) & admStatus= (optional) & page= (optional) & limit= (optional) & sort= (optional) & order= (optional)
  method: "get",
};
export const LOCATION_SEARCH_USER_URL = {
  url: `${BASE_URL}/loc/search/by-user`, // ? username= & status=  & fromDate= (YYYY-MM-DD) & toDate= (YYYY-MM-DD) & page= (optional) & limit= (optional)
  method: "get",
};
export const LOCATION_NEAR_BY_LOCATION_URL = {
  url: `${BASE_URL}/loc/near-by/location`, // */{locationId} ? distance= (in meter. required) & page= (optional) & limit= (optional)
  method: "get",
};
export const LOCATION_LATEST_COMMENTS_URL = {
  url: `${BASE_URL}/loc/comments/latest-comments`,
  method: "get",
};
/*----- Media -----*/
export const MEDIA_GET_UPLOAD_URL = {
  url: `${BASE_URL}/media/get-upload-url`,
  method: "post",
};
/*----- Spam -----*/
export const SPAM_LIST_URL = {
  url: `${BASE_URL}/spam/get-list`, // ? entity= (optional) & type= (optional) & status= (optional) & page= (optional) & limit= (optional)
  method: "get",
};
export const SPAM_VERIFY_URL = {
  url: `${BASE_URL}/spam/verify`, // */{spamId}
  method: "post",
};
/*----- Travalours -----*/
export const TRV_USER_SEARCH_URL = {
  url: `${BASE_URL}/trv-user/search`, // ? name= (optional) & status= (optional) & page= (optional) & limit= (optional) & sort= (optional) & order= (optional)
  method: "get",
};
export const TRV_USER_DETAILS_URL = {
  url: `${BASE_URL}/trv-user/id`, // */{userId}
  method: "get",
};
export const TRV_USER_SUSPEND_URL = {
  url: `${BASE_URL}/trv-user/suspend`, // */{userId}
  method: "post",
};
export const TRV_ACCOUNT_DELETE_REQUEST_URL = {
  url: `${BASE_URL}/trv-user/account-del-req`, //
  method: "get",
};
/*----- Travel Cards -----*/
export const TRAVEL_CARD_SEARCH_URL = {
  url: `${BASE_URL}/travel-card/search`, // ? name= (optional) & status= (optional) & user= (optional) & page= (optional) & limit= (optional) & sort= (optional) & order= (optional)
  method: "get",
};
export const TRAVEL_CARD_DETAILS_URL = {
  url: `${BASE_URL}/travel-card/id`, // */{travelCardId}
  method: "get",
};
export const TRAVEL_CARD_SUSPEND_URL = {
  url: `${BASE_URL}/travel-card/suspend`, // */{travelCardId}
  method: "post",
};
/*----- Trips -----*/
export const TRIP_SEARCH_URL = {
  url: `${BASE_URL}/trip/search`, // ? name= (optional) & status= (optional) & user= (optional) & page= (optional) & limit= (optional) & sort= (optional) & order= (optional)
  method: "get",
};
export const TRIP_DETAILS_URL = {
  url: `${BASE_URL}/trip/id`, // */{tripId}
  method: "get",
};
export const TRIP_SUSPEND_URL = {
  url: `${BASE_URL}/trip/suspend`, // */{tripId}
  method: "post",
};
/*----- Users (Admin) -----*/
export const USER_GET_URL = {
  url: `${BASE_URL}/user`, // */{userId}*
  method: "get",
};

/*----- Reference -----*/
export const GOOGLE_PLACE_ID_FINDER_URL =
  "https://developers-dot-devsite-v2-prod.appspot.com/maps/documentation/javascript/examples/places-placeid-finder";
